<app-inputs
  [Label]="''"
  [dropdown]="!multiselect"
  [value]="record.rule.value"
  [options]="options"
  [multiOptions]="options"
  [multiSelect]="multiselect"
  (onChange)="onSelectionChange($event)"></app-inputs>
